import { useState } from "react";

export const useFormFieldsLoading = () => {
  // This value takes in fieldID + true/false
  // As fields are rendered if the field "knows" it can take a while to render such as field frame is sets the property to true
  // ex: {cardNumber: true}
  // once the field is rendered it updates the state to false
  const [fieldLoadingState, setFieldLoadingState] = useState<
    Record<string, boolean>
  >({});

  const fieldIsLoading = (fieldId: string): void => {
    setFieldLoadingState((fieldLoadingState) => ({
      ...fieldLoadingState,
      [fieldId]: true,
    }));
  };

  const fieldHasLoaded = (fieldId: string): void => {
    setFieldLoadingState((fieldLoadingState) => ({
      ...fieldLoadingState,
      [fieldId]: false,
    }));
  };

  const formSectionHasChanged = (): void => {
    setFieldLoadingState({});
  };

  const formHasPendingLoadingFields = (): Array<string> => {
    // determine the total size of keys which are not ready
    // Ex: {fieldA:false, fieldB: true} = [fieldB]
    return Object.keys(fieldLoadingState).filter(
      (rec) => fieldLoadingState[rec]
    );
  };

  return {
    fieldIsLoading,
    fieldHasLoaded,
    formSectionHasChanged,
    formHasPendingLoadingFields,
    fieldLoadingState,
  };
};
